// extracted by mini-css-extract-plugin
export default {"text":"actions-context-menu_text__K5cHD"};